import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

// styles
import * as styles from "./Button.module.css";

const propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  isExternal: PropTypes.bool,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary", "outline"]),
};

const defaultProps = {
  text: "Button",
  type: "button",
  size: "md",
  onClick: () => {},
  btnClass: "",
  isLoading: false,
  href: null,
  isExternal: false,
  variant: "primary",
};

const Button = ({
  text,
  type,
  size,
  onClick,
  isDisable,
  btnClass,
  isLoading,
  href,
  isExternal,
  variant,
}) => {
  const btnEvent = isLoading ? styles.btnEvent : "";
  const variantClass = styles[variant] || styles.primary;
  const buttonClasses = `btn ${styles.submitBtn} ${variantClass} ${
    "btn-" + size
  } ${btnClass} ${btnEvent}`;

  const handleClick = e => {
    if (onClick) {
      onClick(e);
    }
  };

  const buttonContent = (
    <>
      {isLoading ? (
        <span style={{ position: "relative" }}>
          <i className={styles.btnSpinner}></i>
          <span style={{ opacity: "0.2" }}>{text}</span>
        </span>
      ) : (
        text
      )}
    </>
  );

  // Render as link if href is provided
  if (href) {
    if (isExternal) {
      return (
        <a
          href={href}
          className={buttonClasses}
          onClick={handleClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          {buttonContent}
        </a>
      );
    }
    return (
      <Link to={href} className={buttonClasses} onClick={handleClick}>
        {buttonContent}
      </Link>
    );
  }

  // Render as button
  return (
    <button
      type={type}
      onClick={handleClick}
      className={buttonClasses}
      disabled={isDisable}
    >
      {buttonContent}
    </button>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;

// how to use
// Ex1: <Button text="Signin" />
// Ex2: <Button type="button" text="Signin" onClick={this.handleSignin} />
// Ex3: <Button text="Learn More" href="/about" />
// Ex4: <Button text="External Link" href="https://example.com" isExternal />
// Ex5: <Button text="Click Me" variant="primary" onClick={handleClick} />
